module.exports = __webpack_public_path__ + "static/media/yashna.c19b2115.jpg";